// Copyright (c) 2020 Deere & Company

import './radio-button-filter.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RadioButtonFilterBody from './radio-button-filter-body';
import {translate} from '../../../services/translation-service';

const RadioButtonFilter = props => {

    const radioFilterBody = (
        <RadioButtonFilterBody
            list={props.list}
            onItemUpdate={props.onItemUpdate}
            selectedItem={props.selectedItem}
        />
    );

    return (
        <section className='radio-button-filter'>
            <Accordion
                accordionId='radio-filter-accordion'
                body={radioFilterBody}
                isExpanded={props.isExpanded}
                onClick={props.onClick}
                title={translate(props.title)}
            />
        </section>
    );

};

RadioButtonFilter.displayName = 'RadioButtonFilter';
RadioButtonFilter.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onClick: PropTypes.func.isRequired,
    onItemUpdate: PropTypes.func.isRequired,
    selectedItem: PropTypes.instanceOf(KeyValuePair),
    title: PropTypes.string.isRequired
};

export default RadioButtonFilter;



// WEBPACK FOOTER //
// ./src/shared/components/facets/radio-button-filter/controlled.js